import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Accueil from "@/pages/Accueil";
import Recherche from "@/pages/Recherche";
import Fiche from "@/pages/Fiche";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import Desinscription from "@/pages/Desinscription";
import Confirmer from "@/pages/Confirmer";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/recherche" element={<Recherche />} />
          <Route path="/arrete/:cid/:codeInsee" element={<Fiche />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/desinscrire" element={<Desinscription />} />
          <Route path="/confirmer" element={<Confirmer />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
